import { handleResponse, handleError } from "./apiUtils";
import Config from "../Config";

let loginid = localStorage.getItem("loginUserID");
let Auth0token = localStorage.getItem("Auth0token");
let UserCompanyId = localStorage.getItem("UserCompanyId");

export async function MultipleDeleteChatRoomid(data) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(Config.apiUrl + "ChatMessage/WebUserAllMessageDelete", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      userCompanyID: loginid,
      Authorization: "Bearer " + Auth0token,
    },
    body: JSON.stringify(data),
  })
    .then(handleResponse)
    .catch(handleError);
}

export async function DeleteChatRoomid(Roomid) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(Config.apiUrl + "ChatMessage/AppDelete?roomId=" + Roomid, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      userCompanyID: loginid,
      Authorization: "Bearer " + Auth0token,
    },
  })
    .then(handleResponse)
    .catch(handleError);
}

export async function CleraChatRoomid(Roomid) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(Config.apiUrl + "ChatMessage/AppClearChat?roomId=" + Roomid, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      userCompanyID: loginid,
      Authorization: "Bearer " + Auth0token,
    },
  })
    .then(handleResponse)
    .catch(handleError);
}

export async function BlockAndUnbloakChatRoomid(Roomid) {
  if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
    Auth0token = await localStorage.getItem("Auth0token");
  }
  if (loginid === null || loginid === "" || loginid === undefined) {
    loginid = await localStorage.getItem("loginUserID");
  }
  if (
    UserCompanyId === null ||
    UserCompanyId === "" ||
    UserCompanyId === undefined
  ) {
    UserCompanyId = await localStorage.getItem("UserCompanyId");
  }
  return fetch(Config.apiUrl + "Articles/CreateArticle", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      userCompanyID: loginid,
      Authorization: "Bearer " + Auth0token,
    },
  })
    .then(handleResponse)
    .catch(handleError);
}

  export async function MultipleDeleteEmailChatRoomid(data) {
    if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
      Auth0token = await localStorage.getItem("Auth0token");
    }
    if (loginid === null || loginid === "" || loginid === undefined) {
      loginid = await localStorage.getItem("loginUserID");
    }
    if (
      UserCompanyId === null ||
      UserCompanyId === "" ||
      UserCompanyId === undefined
    ) {
      UserCompanyId = await localStorage.getItem("UserCompanyId");
    }
    return fetch(Config.apiUrl + "emailChatMessage/WebUserAllEmailMessageDelete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(data),
    })
      .then(handleResponse)
      .catch(handleError);
  }


  export async function CleraEmailChatRoomid(Roomid) {
    if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
      Auth0token = await localStorage.getItem("Auth0token");
    }
    if (loginid === null || loginid === "" || loginid === undefined) {
      loginid = await localStorage.getItem("loginUserID");
    }
    if (
      UserCompanyId === null ||
      UserCompanyId === "" ||
      UserCompanyId === undefined
    ) {
      UserCompanyId = await localStorage.getItem("UserCompanyId");
    }
    return fetch(Config.apiUrl + "emailChatMessage/ClearEmailChatByadmin?roomId=" + Roomid, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    })
      .then(handleResponse)
      .catch(handleError);
  }


  export async function HideEmailChatRoomid(Roomid) {
    if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
      Auth0token = await localStorage.getItem("Auth0token");
    }
    if (loginid === null || loginid === "" || loginid === undefined) {
      loginid = await localStorage.getItem("loginUserID");
    }
    if (
      UserCompanyId === null ||
      UserCompanyId === "" ||
      UserCompanyId === undefined
    ) {
      UserCompanyId = await localStorage.getItem("UserCompanyId");
    }
    return fetch(Config.apiUrl + "emailChatMessage/HideEmailChatByadmin?roomId=" + Roomid, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    })
      .then(handleResponse)
      .catch(handleError);
  }

  export async function DeleteemailChatRoomid(Roomid) {
    if (Auth0token === null || Auth0token === "" || Auth0token === undefined) {
      Auth0token = await localStorage.getItem("Auth0token");
    }
    if (loginid === null || loginid === "" || loginid === undefined) {
      loginid = await localStorage.getItem("loginUserID");
    }
    if (
      UserCompanyId === null ||
      UserCompanyId === "" ||
      UserCompanyId === undefined
    ) {
      UserCompanyId = await localStorage.getItem("UserCompanyId");
    }
    return fetch(Config.apiUrl + "emailChatMessage/WebUserEmailMessageDelete?roomId=" + Roomid, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    })
      .then(handleResponse)
      .catch(handleError);
  }
  